import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { BulkChangesPageComponent } from "./components/bulk-changes-page/bulk-changes-page.component";

export function getBulkChangesRoutes(): Route[] {
  return [
    {
      path: 'bulk-changes',
      component: BulkChangesPageComponent,
      title: 'Bulk Changes',
      canActivate: [authGuard]
    },
  ];
}
